export default __webpack_public_path__ + "static/media/sumaB.04ead04a.jpg";